import { ExperienceFragment } from './fragments/Experience';

export const ExperienceList = /* GraphQL */ `
  query ExperienceList {
    ExperienceList {
      ${ExperienceFragment}
    }
  }
`;
